export default __webpack_public_path__ + "static/media/sad-brutus.21821c2a.jpg";